module.exports = __webpack_public_path__ + "static/media/06-entrega.3927151e.png";